import { render } from "./DocumentacaoPortfolioAuditor.vue?vue&type=template&id=272057dc"
import script from "./DocumentacaoPortfolioAuditor.vue?vue&type=script&lang=js"
export * from "./DocumentacaoPortfolioAuditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__